import type { SetupWorker } from 'msw'
import { setupWorker } from 'msw'

import defaultHandlers, * as handlers from './handlers/browser'

// This configures a Service Worker with the given request handlers.
export const worker = setupWorker(...defaultHandlers)

declare global {
  interface Window {
    ENABLE_MOCKED_SERVICE_WORKER: boolean
    COGNITO_BASE_URL: string
    MOCKS: {
      worker: SetupWorker
      handlers: typeof handlers
    }
  }
}

window.MOCKS = {
  worker,
  handlers,
}
